/**
 * 枚举 actions
 */
import { 
  iReviewStatusEnum, 
  SET_REVIEW_STATUS_ENUM,
  iBatchTaskFuncTypeEnum,
  SET_BATCH_TASK_FUNC_TYPES,
  iBatchTaskStatusEnum,
  SET_BATCH_TASK_STATUSES
} from './type';

export function setReviewStatusEnum(reviewStatusEnum: iReviewStatusEnum[]) {
  return {
    type: SET_REVIEW_STATUS_ENUM,
    payload: reviewStatusEnum,
  };
}

export function setBatchTaskFuncTypes(funcTypes: iBatchTaskFuncTypeEnum[]) {
  return {
    type: SET_BATCH_TASK_FUNC_TYPES,
    payload: funcTypes,
  };
}

export function setBatchTaskStatuses(statuses: iBatchTaskStatusEnum[]) {
  return {
    type: SET_BATCH_TASK_STATUSES,
    payload: statuses,
  };
}
